<template>
    <div class="pcr-client-establishment-details">
        <img v-if="establishment.HasLogo" :src="establishment.LogoUrl" class="avatar">
        <div style="text-align:center;">
            <h3 style="text-align:center;">
                <span>{{establishment.Name}}</span>
            </h3>
            <a href="" @click="showModal">Plus de details...</a>
        </div>

        <el-dialog title="" :visible.sync="show" size="small">
            <h2>{{establishment.Name}}</h2>
            <el-tabs type="border-card">
                <el-tab-pane label="Informations">
                    <el-row :gutter="12">
                        <el-col :span="12">
                            <ck-informations label="Gestionnaire" :display="establishment.PartnerName"></ck-informations>
                        </el-col>
                        <el-col :span="12">
                            <ck-informations label="Contact Gestionnaire" :display="$linebreakToBR(establishment.PartnerContactInformations)"></ck-informations>
                        </el-col>
                    </el-row>
                    <el-row :gutter="12">
                        <el-col :span="12">
                            <ck-informations label="Groupement" :display="establishment.ManagingName"></ck-informations>
                        </el-col>
                        <el-col :span="12">
                            <ck-informations label="Contact Groupement" :display="$linebreakToBR(establishment.ManagingContactInformations)"></ck-informations>
                        </el-col>
                    </el-row>

                    <el-row :gutter="12">
                        <el-col :span="24">
                            <ck-informations label="Type d'établissement" :display="establishment.Type"></ck-informations>
                        </el-col>
                    </el-row>

                    <el-row :gutter="12">
                        <el-col :span="24">
                            <ck-informations label="Adresse" :display="address"></ck-informations>
                        </el-col>
                    </el-row>
                    
                    <el-row :gutter="12">
                        <el-col :span="24">
                            <ck-informations label="Informations de contact" :display="$linebreakToBR(establishment.ContactInformations)"></ck-informations>
                        </el-col>
                    </el-row>
                </el-tab-pane>

                <el-tab-pane label="Groupes">
                    <div class="tabbable tabs-left">
                        <ul class="nav nav-tabs">
                            <li v-for="(value) in filteredGroups" :key="value.GroupId" :class="{ active: value.GroupId == activeGroupId }" @click="activateGroup(value.GroupId)">
                                <a href="#">{{value.GroupName}}</a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane" :class="{ active: value.GroupId == activeGroupId }" v-for="(value) in filteredGroups" :key="value.GroupId">
                                <el-card class="box-card">
                                    <div v-for="user in value.users" :key="user.UserId" class="text item">
                                        <i class="fa fa-user" aria-hidden="true"></i> {{user.FullName}} <span v-show="user.Role">– {{user.Role}}</span>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('pcr-client-establishment-details', {
    props: {
        establishmentId: {
            default: () => 0
        },
    },
    data() {
        return {
            show: false,
            refreshing: false,
            establishment: {},
            groups: [],
            activeGroupId: 0
        }
    },
    computed: {
        filteredGroups() {
            return _.filter( this.groups, (item) => item.UserCount > 0 );
        },
        address() {
            let address = '';

            if (this.establishment.Address) address += this.establishment.Address + '<br />';
            if (this.establishment.AddressComp) address += this.establishment.AddressComp + '<br />';
            if (this.establishment.ZipCode) address += this.establishment.ZipCode;
            if (this.establishment.City) address += " - " + this.establishment.City;

            return address;
        }
    },
    mounted: function() {
        this.refresh();
    },
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get(`/api/establishment/${this.establishmentId}`).then((response) => {
                    this.establishment = response.data;
                });


                this.$http.get(`/api/establishment/${this.establishmentId}/groups`).then((response) => {
                    this.groups = response.data;

                    _.each(this.filteredGroups, (item, index) => {
                        this.$http.get(`/api/group/${item.GroupId}/users`).then((response) => {
                            let group = _.find( this.groups, x => x.GroupId == item.GroupId )
                            group.users = response.data;
                        });
                    });

                    this.activeGroupId = this.filteredGroups[0].GroupId;
                });
            }
        },
        showModal(e) {
            e.preventDefault();

            this.show = true;
        },
        activateGroup(groupId) {
            console.log('activateGroup', groupId)
            this.activeGroupId = groupId;
        }
    },
    watch: {
    }
});
</script>

<style lang="scss">
$logoSize: 92px;
.avatar {
    width: $logoSize;
    height: $logoSize;
    float: left;
    margin-top: -16px;
}

.el-dialog__body {
    padding-top: 8px;
}

.el-dialog__header {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/client/pcr-client-establishment-details.vue